<template>
    <div class="baby-home-page">
        <header class="record-header">
            <button type="button" class="album-entry" @click="goAlbum">
                <span>相册</span>
                <b>宝宝相册</b>
            </button>
        </header>

        <section class="hero-panel">
            <div class="hero-date">
                <div class="date-number">{{ profile.dateNumber }}</div>
                <div class="date-meta">
                    <div class="date-week">{{ profile.weekText }}</div>
                    <div class="date-month">{{ profile.monthText }}</div>
                </div>
            </div>
            <div class="hero-age">{{ profile.ageText }}</div>
            <div class="hero-copy">
                <h1>{{ profile.heroTitle }}</h1>
                <p>{{ profile.heroSubtitle }}</p>
            </div>
            <div class="hero-illustration">
                <div class="hill"></div>
                <div class="figure figure-left"></div>
                <div class="figure figure-right"></div>
                <div class="flag"></div>
            </div>
        </section>

        <button type="button" class="daily-care-entry" @click="goDailyCare">
            <span class="daily-care-icon">必</span>
            <span class="daily-care-copy">
                <b>每日照护任务</b>
                <em>奶量、辅食、小儿推拿按日完成</em>
            </span>
            <span class="daily-care-action">进入</span>
        </button>

        <section class="tool-panel">
            <button
                v-for="tool in toolList"
                :key="tool.key"
                type="button"
                class="tool-card"
                @click="handleTool(tool)"
            >
                <span class="tool-icon" :style="{ background: tool.color }">{{ tool.symbol }}</span>
                <span class="tool-label">{{ tool.label }}</span>
                <span class="tool-desc">{{ tool.description }}</span>
            </button>
        </section>

        <button type="button" class="smart-upload" @click="goAlbum({ compose: 'smart-upload' })">
            <span class="upload-badge">相册</span>
            <span class="upload-text">智能上传</span>
        </button>
    </div>
</template>

<script>
import { babyProfile, babyToolList } from './mock';

export default {
    name: 'BabyHome',
    components: {},
    data () {
        return {
            profile: babyProfile,
            toolList: babyToolList
        };
    },
    methods: {
        goAlbum (query = {}) {
            this.$router.push({
                path: '/baby/album',
                query: {
                    ...this.$route.query,
                    ...query
                }
            });
        },
        handleTool (tool) {
            if (tool.key === 'album') {
                this.goAlbum();
                return;
            }

            if (tool.key === 'camera') {
                this.goAlbum({
                    compose: tool.key
                });
                return;
            }

            this.$toast(`${tool.label}能力已预留，等待接口接入`);
        },
        goDailyCare () {
            this.$router.push({
                path: '/tcm-study/home',
                query: {
                    ...this.$route.query
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.baby-home-page {
    min-height: 100%;
    padding: 12px 18px 40px;
    background:
        radial-gradient(circle at top left, rgba(252, 210, 205, 0.55), transparent 32%),
        radial-gradient(circle at top right, rgba(255, 223, 139, 0.65), transparent 26%),
        linear-gradient(180deg, #faf7f1 0%, #f6f0ea 100%);
    font-family: 'SF Pro Display', 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.record-header {
    min-height: 38px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 6px;
}

.album-entry {
    min-height: 36px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 0 12px;
    border: 1px solid rgba(117, 160, 255, 0.24);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.82);
    color: #4b6edb;
    box-shadow: 0 8px 18px rgba(80, 78, 95, 0.08);
}

.album-entry span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 22px;
    border-radius: 11px;
    background: #eef3ff;
    font-size: 12px;
    font-weight: 700;
}

.album-entry b {
    font-size: 14px;
    line-height: 18px;
}

.hero-panel {
    position: relative;
    min-height: 280px;
    padding: 8px 4px 24px;
}

.daily-care-entry {
    width: 100%;
    min-height: 88px;
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 0 0 16px;
    padding: 14px;
    border: 0;
    border-radius: 8px;
    background: linear-gradient(135deg, #e7f6ef 0%, #fff4df 100%);
    box-shadow: 0 14px 30px rgba(80, 78, 95, 0.1);
    text-align: left;
}

.daily-care-icon {
    flex: none;
    width: 52px;
    height: 52px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: #2e8b7a;
    color: #fff;
    font-size: 22px;
    font-weight: 800;
}

.daily-care-copy {
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.daily-care-copy b {
    color: #1f2f2c;
    font-size: 20px;
    line-height: 26px;
}

.daily-care-copy em {
    color: #66706d;
    font-style: normal;
    font-size: 12px;
    line-height: 17px;
}

.daily-care-action {
    flex: none;
    min-width: 44px;
    color: #2e8b7a;
    font-size: 14px;
    font-weight: 700;
    text-align: right;
}

.hero-date {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.date-number {
    color: #4f4d51;
    font-size: 56px;
    font-weight: 300;
    line-height: 1;
}

.date-meta {
    padding-top: 10px;
    color: #7b7a80;
    font-size: 14px;
}

.date-week {
    margin-bottom: 4px;
    font-weight: 600;
}

.hero-age {
    margin-top: 12px;
    color: #60606a;
    font-size: 26px;
    font-weight: 300;
}

.hero-copy {
    max-width: 240px;
    margin-top: 18px;
}

.hero-copy h1 {
    margin: 0 0 10px;
    color: #2a2d38;
    font-size: 24px;
    line-height: 1.2;
}

.hero-copy p {
    margin: 0;
    color: #7e8696;
    font-size: 14px;
    line-height: 1.6;
}

.hero-illustration {
    position: absolute;
    top: 14px;
    right: 6px;
    width: 128px;
    height: 128px;
}

.hill {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 118px;
    height: 54px;
    border-radius: 60px 60px 18px 18px;
    background: linear-gradient(180deg, #bbf0c6, #7fcf91);
}

.figure {
    position: absolute;
    bottom: 34px;
    width: 10px;
    border-radius: 10px;
}

.figure::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    width: 12px;
    height: 12px;
    margin-left: -6px;
    border-radius: 50%;
    background: inherit;
}

.figure-left {
    left: 46px;
    height: 34px;
    background: #ff7780;
}

.figure-right {
    left: 76px;
    height: 42px;
    background: #4b91ff;
}

.flag {
    position: absolute;
    top: 8px;
    right: 24px;
    width: 4px;
    height: 46px;
    background: #7ca7ff;
}

.flag::before {
    content: '';
    position: absolute;
    top: 0;
    left: 4px;
    width: 20px;
    height: 14px;
    border-radius: 2px;
    background: linear-gradient(180deg, #6da2ff, #90c2ff);
    transform: skewY(-14deg);
}

.tool-panel {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    padding: 24px 14px;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.76);
    box-shadow: 0 16px 40px rgba(80, 78, 95, 0.08);
    backdrop-filter: blur(14px);
}

.tool-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: center;
}

.tool-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    box-shadow: 0 8px 18px rgba(80, 78, 95, 0.16);
}

.tool-label {
    color: #424754;
    font-size: 14px;
    font-weight: 600;
}

.tool-desc {
    max-width: 72px;
    color: #8a90a0;
    font-size: 11px;
    line-height: 1.4;
}

.smart-upload {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    margin-top: 18px;
    padding: 18px 20px;
    border: 0;
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.82);
    box-shadow: 0 14px 30px rgba(80, 78, 95, 0.08);
    color: #3d4250;
}

.upload-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 48px;
    height: 28px;
    padding: 0 10px;
    border-radius: 999px;
    background: linear-gradient(135deg, #ffe3b3, #ffcf70);
    color: #e67c02;
    font-size: 12px;
    font-weight: 700;
}

.upload-text {
    font-size: 18px;
    font-weight: 600;
}
</style>
